import {StandardDateRange} from "@/lib/queries/reports.ts";
import {EXPLORER_VIEW_PARAM} from "@/pages/metricsExplorer/explorerConfig.ts";

/**
 * Explorer link that opens a saved chart over the same rolling window.
 *
 * Only the view id and the range go in, not a serialized config: the config lives on the
 * server already, and linking by id means the link opens the chart as it is saved now
 * rather than as it was when the dashboard was built.
 *
 * The range is passed as the picker's own fixed-range param, so the window stays rolling
 * exactly like the widget's. Pinning `start`/`end` instead would freeze it at the moment
 * the link was clicked.
 */
export const buildExplorerViewLink = (viewId: number, timeRange: StandardDateRange | string): string => {
  const params = new URLSearchParams();
  params.set(EXPLORER_VIEW_PARAM, String(viewId));
  params.set("range", timeRange);
  return `/metrics-explorer?${params.toString()}`;
};
